<template>
  <div class="plv-ia-pre-redpacket">
    <Loading v-if="isLoading"/>
    <template v-else>
      <div class="plv-ia-pre-redpacket-header">
        <div class="plv-ia-pre-redpacket-header-left">
          <span class="plv-ia-pre-redpacket-header-left-text">{{ t('plvIA.redpacket.preRedEnvelopes') }}：</span>
          <span class="plv-ia-pre-redpacket-header-left-ico-tip"></span>
          <span class="plv-ia-pre-redpacket-header-left-tip">{{ t('plvIA.redpacket.preRedpacketMsg') }}</span>
        </div>
      </div>
      <div class="plv-ia-pre-redpacket-list">
        <c-table
          class="plv-ia-pre-redpacket-table"
          :columns="columns"
          :data-list="dataList"
          tbody-height="240px"
        >
          <template v-slot:handle="slotData">
            <div class="plv-ia-pre-redpacket-list-handle-btn">
              <span @click="sendPreRedpacket(slotData.slotData)">{{ t('plvIA.redpacket.sendBtn')}}</span>
              <span @click="choosePreRedpacket(slotData.slotData)">{{ t('plvIA.redpacket.detail') }}</span>
            </div>
          </template>
        </c-table>
        <plv-pagination
          class="plv-ia-pre-redpacket-list-pagination"
          :total="totalPages"
          :page-size.sync="pageSize"
          v-model="pageNumber"
          :layout="['prev', 'pager', 'next']"
          @currentChange="currentChange"
        />
      </div>
      <div class="plv-ia-pre-redpacket-bottom">
        <div class="plv-ia-pre-redpacket-bottom-btn--back" @click="$emit('change-current-step', step.createRedpacket)">
          {{ t('plvIA.redpacket.btnBack') }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CTable from '../../../components/table/Table';
import { step } from '../config';
import Locale from '@/mixins/locale';
import commonMixin from '../../app-mixin';
import { Pagination } from '@polyv/polyv-ui';
import Loading from '../../../components/loading/Loading';

export default {
  name: 'pre-redpacket',
  components: {
    CTable,
    Loading,
    'plv-pagination': Pagination
  },
  props: {
    core: {
      type: Object,
      default: null
    }
  },
  mixins: [Locale, commonMixin],
  watch: {
    lang() {
      this.initColumns();
    }
  },
  data() {
    // 列表配置
    return {
      step,
      columns: [],
      dataList: [],
      pageSize: 5,
      pageNumber: 1,
      totalPages: 1,
      isLoading: false
    };
  },
  beforeMount() {
    this.initColumns();
  },
  mounted() {
    this.getPreRedPacketList();
  },
  methods: {
    async getPreRedPacketList() {
      this.isLoading = true;
      let result;
      try {
        result = await this.core.getPreRedPacketList(this.pageNumber);
      } finally {
        this.isLoading = false;
      }
      const preYuan = this.t('plvIA.redpacket.preYuan');
      const preGe1 = this.t('plvIA.redpacket.preGe1');
      const preGe2 = this.t('plvIA.redpacket.preGe2');
      result.contents.map(item => {
        item.redPackTypeTitle = this.formatRedPackType(item.redPackType) + '-' + this.formatRedPackAllotType(item.allotType);
        item.methodsTitle = item.minutes ? this.t('plvIA.redpacket.countdownMinute', { minutes: item.minutes }) : this.t('plvIA.redpacket.immediateRelease');
        item.statusTitle = this.t('plvIA.redpacket.preRedpacketUnissued');
        if (item.allotType === 'average') {
          const averageList = [];
          item.averageList.forEach(obj => {
            averageList.push(`${obj.redPackCount}${preGe2}${obj.redPackAmount}${preYuan}`);
          });
          item.countAmountTitle = averageList.join(',');
        } else {
          item.countAmountTitle = `${item.redPackCount}${preGe1}${item.amount}${preYuan}`;
        }
        return item;
      });
      this.dataList = result.contents;
      this.totalPages = result.totalPages;
    },
    formatRedPackType(type) {
      let title = '';
      switch (type) {
        case 'RAIN':
          title = this.t('plvIA.redpacket.redpacketRain');
          break;
        case 'PASSWORD':
          title = this.t('plvIA.redpacket.passwordRedpacket');
          break;
        case 'OFFICIAL_NORMAL':
          title = this.t('plvIA.redpacket.normalRedpacket');
          break;
        default:
          title = this.t('plvIA.redpacket.normalRedpacket');
          break;
      }
      return title;
    },
    formatRedPackAllotType(allotType) {
      let title = this.t('plvIA.redpacket.preRedpacketAllotRandom');
      if (allotType === 'random') {
        title = this.t('plvIA.redpacket.preRedpacketAllotRandom');
      } else if (allotType === 'average') {
        title = this.t('plvIA.redpacket.preRedpacketAllotAverage');
      }
      return title;
    },
    currentChange(page) {
      this.pageNumber = page;
      this.getPreRedPacketList();
    },
    initColumns() {
      this.columns = [
        {
          props: 'redpackName',
          label: this.t('plvIA.redpacket.preRedpacketName'),
          textAlign: 'left',
        },
        {
          props: 'redPackTypeTitle',
          label: this.t('plvIA.redpacket.preRedpacketTypeTable'),
          width: '110px'
        },
        {
          props: 'countAmountTitle',
          label: this.t('plvIA.redpacket.amountQuantity'),
          width: '100px'
        },
        {
          props: 'methodsTitle',
          label: this.t('plvIA.redpacket.sendMethod'),
          width: '100px'
        },
        {
          props: 'statusTitle',
          label: this.t('plvIA.redpacket.state'),
          width: '100px'
        },
        {
          type: 'handle',
          label: this.t('plvIA.redpacket.operation'),
          width: '120px'
        }
      ];
    },
    choosePreRedpacket(data) {
      this.$emit('open-pre-redpacket-detail', data);
    },
    sendPreRedpacket(data) {
      this.$emit('send-pre-redpacket', data);
    },
  }
};
</script>

<style lang="scss">
@import '@polyv/polyv-ui/lib-admin/theme/iconfont.css';
.plv-ia-pre-redpacket-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  .plv-ia-pre-redpacket-header-left {
    display: flex;
    align-items: center;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
  }
  .plv-ia-pre-redpacket-header-left-text {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }
  .plv-ia-pre-redpacket-header-left-ico-tip {
    background-image: url('../images/icon-tip.png');
    background-size: 100% 100%;
    width: 16px;
    height: 16px;
    display: inline-block;
    margin-right: 9px;
  }
}
.plv-ia-pre-redpacket-bottom {
  text-align: center;
}
.plv-ia-pre-redpacket-bottom-btn--back {
  margin-top: 20px;
  display: inline-block;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background-color: #2196F3;
  border-radius: 16px;
  padding: 0 20px;
  color: #FFFFFF;
}
.plv-ia-pre-redpacket-bottom-btn--back:hover {
  cursor: pointer;
}
.plv-ia-pre-redpacket-list {
  width: 100%;
}
.plv-ia-pre-redpacket-list-pagination {
  margin-top: 24px;
}
.plv-ia-pre-redpacket-table {
  border-bottom: 1px solid #E7E7E7;
}

.plv-ia-pre-redpacket-list-handle-btn {
  display: flex;
  color: #2196F3;
  justify-content: center;
  span {
    padding: 0 4px;
  }
  span:hover {
    cursor: pointer;
  }
}

</style>
